/**
 * Materiaalgroep-classificatie — één bron van waarheid.
 *
 * Zowel de contextpaneel-cluster-tabs (Werkbladen/Verlichting/Beslag/…) als de
 * drag-and-drop-routing naar de juiste offerte-sectie gebruiken deze predicaten,
 * zodat ze het altijd eens zijn: wat onder "Werkbladen" in het paneel staat,
 * belandt bij slepen ook in de Werkbladen-sectie van de offerte.
 *
 * Matcht op naam + code, dus tenant-agnostisch (groep-id's verschillen per tenant).
 */

const test = (g, re) => re.test(`${g?.naam || ''} ${g?.code || ''}`)

export const WERKBLAD_PREDIKAAT = (g) => test(g, /werkblad/i)
export const VERLICHTING_PREDIKAAT = (g) => test(g, /verlicht/i)
export const BESLAG_PREDIKAAT = (g) => test(g, /beslag/i)
// Quooker is een eigen groep en hoort NOOIT onder Sanitair -> /sanitair/i sluit Quooker uit.
export const SANITAIR_PREDIKAAT = (g) => test(g, /sanitair/i)
export const PLINTEN_PREDIKAAT = (g) => test(g, /plint/i)
export const DRESSING_PREDIKAAT = (g) => test(g, /dressing/i)
// /gree?p/ matcht zowel "Grepen" als "Greepprofielen".
export const GREPEN_PREDIKAAT = (g) => test(g, /gree?p/i)

/**
 * Verzamel de groep-objecten van een materiaal (primaire id + many-to-many)
 * via een id->groep Map (bv. opgebouwd uit GET /materiaal-groepen).
 */
export function groepenVanMateriaal(mat, groepById) {
  const out = []
  const push = (id) => {
    const g = groepById?.get?.(id)
    if (g) out.push(g)
  }
  if (mat?.materiaal_groep_id != null) push(mat.materiaal_groep_id)
  if (Array.isArray(mat?.materiaal_groep_ids)) mat.materiaal_groep_ids.forEach(push)
  return out
}

/**
 * Bepaal in welke offerte-sectie een materiaal thuishoort o.b.v. zijn groep(en).
 * Volgorde = prioriteit als een materiaal in meerdere groepen zit.
 * Retourneert: 'werkblad' | 'verlichting' | 'plinten' | 'divers'.
 */
export function materiaalSectie(mat, groepById) {
  const groepen = groepenVanMateriaal(mat, groepById)
  const any = (pred) => groepen.some(pred)
  if (any(WERKBLAD_PREDIKAAT)) return 'werkblad'
  if (any(VERLICHTING_PREDIKAAT)) return 'verlichting'
  if (any(PLINTEN_PREDIKAAT)) return 'plinten'
  return 'divers'
}
